import "./AskPageApp.css";
import { AskConsumerLayout } from "@ui/layouts/AskConsumerLayout/AskConsumerLayout";
import { VStack } from "@ui/Stack";
import { createSignal, onMount, Show } from "solid-js";
import { takeQuestionHandoffFor } from "~/modules/askgvt/public-profile/askPageQuestionHandoff";
import { saveRecentlyViewedCreator } from "~/modules/shared/utils/recentlyViewedCreators";
import { AskComposer } from "./AskComposer";
import { viewerIsOwner } from "./askPageAccess";
import { AskFooter } from "./components/AskFooter";
import { AskPageBoardClipPane } from "./components/AskPageBoardClipPane";
import { BoardsShelf } from "./components/BoardsShelf";
import { ConnectedChannels } from "./components/ConnectedChannels";
import { CreatorIdentity } from "./components/CreatorIdentity";
import { Paywall } from "./components/Paywall";
import { TierRow } from "./components/TierRow";
import { type AskPagePrice, askPageVars } from "./pageVars";
import { useAskPageBoardClipPlayback } from "./useAskPageBoardClipPlayback";
import { useAskPageJoin } from "./useAskPageJoin";

export const AskPageApp = () => {
	const vars = askPageVars();
	const boardClipPlayback = useAskPageBoardClipPlayback();
	const [prefill, setPrefill] = createSignal<string | undefined>(undefined);
	const [autoSubmit, setAutoSubmit] = createSignal(false);
	const [paywallOpen, setPaywallOpen] = createSignal(false);
	const [paywallType, setPaywallType] = createSignal<
		AskPagePrice["type"] | undefined
	>();

	const openPaywall = (type?: AskPagePrice["type"]) => {
		setPaywallType(type);
		setPaywallOpen(true);
	};

	const scrollToAccessNotice = () => {
		document.getElementById("ask-page-access")?.scrollIntoView({
			behavior: "smooth",
			block: "start",
		});
	};

	const {
		join,
		busy,
		error: joinError,
	} = useAskPageJoin({
		onPaidJoin: scrollToAccessNotice,
		displayName: vars.influencer_display_name,
	});

	onMount(() => {
		saveRecentlyViewedCreator({
			influencerId: vars.influencer_id,
			handle: vars.influencer_handle,
			displayName: vars.influencer_display_name,
			avatarUrl: vars.influencer_avatar_url,
		});
		if (vars.isSignedIn) {
			const text = takeQuestionHandoffFor(vars.influencer_handle);
			if (text !== undefined) {
				setPrefill(text);
				setAutoSubmit(true);
			}
		}
	});

	return (
		<AskConsumerLayout
			title={vars.influencer_display_name}
			hasHeaderMargin={false}
			signedOutTopNav
		>
			<div class="askgvt1-ask-page-shell">
				<div class="askgvt1-creator-page">
					<CreatorIdentity
						onJoin={() => void join()}
						joinBusy={busy}
						joinError={joinError}
					/>
					<div class="askgvt1-page">
						<VStack spacing="xxlarge">
							<AskComposer
								prefill={prefill()}
								autoSubmit={autoSubmit()}
								handle={vars.influencer_handle}
								isSignedIn={vars.isSignedIn}
								onJoin={() => void join()}
							/>
							{/* <Show when={vars.is_paid_ask_page && !viewerIsOwner(vars.status)}>
							<div id="ask-page-access" class="askgvt1-access">
								<AskPageAccessNotice
									handle={vars.influencer_handle}
									isSignedIn={vars.isSignedIn}
									isEntitled={viewerIsSubscribed(vars.status)}
									prices={vars.prices}
								/>
							</div>
						</Show> */}
							<Show when={!viewerIsOwner(vars.status)}>
								<TierRow onJoin={openPaywall} id="ask-page-access" />
							</Show>
							<Paywall
								open={paywallOpen}
								onClose={() => setPaywallOpen(false)}
								initialType={paywallType}
							/>

							<BoardsShelf
								onPlayClip={(boardId, clipId) => {
									boardClipPlayback.openClip(boardId, clipId);
								}}
							/>
							<ConnectedChannels />
						</VStack>
					</div>
					<AskFooter />
				</div>
				<AskPageBoardClipPane
					playback={boardClipPlayback}
					showAddToBoardButton={vars.isSignedIn}
				/>
			</div>
		</AskConsumerLayout>
	);
};
